import { render, staticRenderFns } from "./event-point.vue?vue&type=template&id=18c78c34&scoped=true&"
import script from "./event-point.vue?vue&type=script&lang=js&"
export * from "./event-point.vue?vue&type=script&lang=js&"
import style0 from "./event-point.vue?vue&type=style&index=0&id=18c78c34&prod&scoped=true&lang=css&"
import style1 from "./event-point.vue?vue&type=style&index=1&id=18c78c34&prod&lang=scss&scoped=true&"
import style2 from "./event-point.vue?vue&type=style&index=2&id=18c78c34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c78c34",
  null
  
)

export default component.exports